import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.showModal()
  }

  click_outside(event) {
    if (event.target === this.element) {
      this.element.close()
    }
  }

  close() {
    this.element.close()
  }
}
